export default {
  add(state, marker) {
    state.markers.push(marker);
  },

  select(state, marker) {
    state.selected = marker;
  },

  deselect(state) {
    state.selected = null;
  },

  addVisibleMarkers(state, id) {
    if (!state.visible.includes(id)) {
      state.visible.push(id);
    }
  },

  removeVisibleMarkers(state, id) {
    if (state.visible.includes(id)) {
      const index = state.visible.indexOf(id);

      state.visible.splice(index, 1);
    }
  },
};
